import { render } from "./ForgotPasswordView.vue?vue&type=template&id=140c0266&scoped=true"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=js"

import "./ForgotPasswordView.vue?vue&type=style&index=0&id=140c0266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140c0266"]])

export default __exports__